import type { ThemeConfig } from 'antd'

export const antTheme: ThemeConfig = {
  hashed: true,
  zeroRuntime: true,
  // algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: 'rgb(21, 128, 61)',
    colorPrimaryHover: 'var(--color-primary-600)',
    colorPrimaryActive: 'var(--color-primary-700)',
    colorPrimaryBg: '#dcfce7',
    colorPrimaryBgHover: 'var(--color-primary-200)',
    colorPrimaryBorder: 'var(--color-primary-300)',
    colorLink: 'rgb(21, 128, 61)',
    colorLinkHover: 'rgb(0, 9, 3)',
    colorLinkActive: 'rgb(0, 9, 3)',
    controlHeightSM: 32,
    controlHeight: 40,
    controlHeightLG: 48,
    controlOutline: 'none',
    // colorIconHover: 'var(--color-primary-500)',
    colorText: 'var(--color-gray-700)',
    colorTextSecondary: 'var(--color-gray-600)',
    colorTextTertiary: 'var(--color-gray-500)',
    colorTextQuaternary: 'var(--color-gray-300)',
    colorSplit: 'var(--color-gray-300)',
  },
  components: {
    Card: {
      colorBorder: 'var(--color-gray-300)',
    },
    Drawer: {
      colorBgElevated: 'var(--color-gray-50)',
    },
    Tabs: {
      itemSelectedColor: 'var(--color-gray-700)',
      itemHoverColor: 'var(--color-gray-700)',
      itemColor: 'var(--color-gray-500)',
      inkBarColor: 'var(--color-gray-600)',
      horizontalMargin: '0',
    },
    Input: {
      // hoverBorderColor: 'var(--color-primary-500)',
      // activeBorderColor: 'var(--color-primary-500)',
    },
    Button: {
      paddingInline: 'calc(var(--spacing) * 5)',
      // colorPrimary: 'var(--color-primary-500)',
      // colorPrimaryHover: 'var(--color-primary-500)',
      // textTextColor: 'var(--color-primary-500)',
      // textTextHoverColor: 'var(--color-primary-500)',
      textHoverBg: 'transparent',
    },
    Menu: {
      activeBarHeight: 0,
      itemSelectedBg: 'var(--color-primary-100)',
      itemSelectedColor: 'var(--color-primary-700)',
    },
    Layout: {
      headerBg: 'white',
      footerBg: 'var(--color-secondary-500)',
      bodyBg: 'white',
      colorBorder: 'transparent',
      headerHeight: '4rem',
    },
    Form: {
      itemMarginBottom: 12,
    },
    Table: {
      // rowSelectedBg: 'var(--color-primary-100)',
      // rowSelectedHoverBg: 'var(--color-primary-200)',
    },
    Select: {
      selectorBg: '#ffffff',
      optionSelectedBg: 'var(--color-gray-300)',
      optionActiveBg: 'var(--color-gray-100)',
    },
    Radio: {
      // buttonSolidCheckedBg: 'var(--color-primary-500)',
      // buttonSolidCheckedHoverBg: 'var(--color-primary-500)',
      // buttonSolidCheckedColor: '#ffffff',
    },
  },
}
